import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { RiCustomerServiceFill } from "react-icons/ri";
import { GrUserAdmin, GrUserExpert } from "react-icons/gr";
import PersonIcon from "@mui/icons-material/Person";
import LanguageIcon from "@mui/icons-material/Language";
import SecurityIcon from "@mui/icons-material/Security";
import WalletIcon from "@mui/icons-material/Wallet";
import VoicemailIcon from "@mui/icons-material/Voicemail";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReceiptIcon from "@mui/icons-material/Receipt";

export const validPermissions = [
  "CONSULTANT",
  "USER",
  "LANGUAGE",
  "PLANS",
  "ROLES",
  "PERMISSIONS",
  "TRANSACTIONS",
  "SERVICE",
  "EXPERTISE",
  "RECHARGE",
  "AUDIO",
  "CREDENTIALS",
  "BANK_ACCOUNTS",
  "TRANSFER_FUNDS",
  "SUB_ADMIN",
  "DASHBOARD",
];

export const rawMenu = [
  {
    key: "/dashboard",
    name: "Dashboard",
    element: <DashboardIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/dashboard",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/consultant",
    name: "Consultant",
    element: <PeopleOutlineIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/consultant",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/user",
    name: "User",
    element: <PersonIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/user",
    style: { background: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/language",
    name: "Language",
    element: <LanguageIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/language",
    style: { background: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/service",
    name: "Service",
    element: <GrUserExpert style={{ fontSize: "1.1rem" }} />,
    path: "/admin/service",
    style: { background: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/expertise",
    name: "Expertise",
    element: <RiCustomerServiceFill style={{ fontSize: "1.1rem" }} />,
    path: "/admin/expertise",
    fontSize: "1rem",
  },
  {
    key: "/plan",
    name: "Plans",
    element: <WalletIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/plan",
    fontSize: "1rem",
  },
  {
    key: "/consultant_recording",
    name: "Consultant Recordings",
    element: <VoicemailIcon style={{ fontSize: "1rem" }} />,
    path: "/admin/consultant_recording",
    fontSize: "1rem",
  },
  {
    key: "/credentials",
    name: "Credentials",
    element: <SecurityIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/credentials",
    style: { background: "white", color: "white", marginBottom: "20px" },
    fontSize: "1rem",
  },
  {
    key: "/transfer_funds",
    name: "Transfer Funds",
    element: <AccountBalanceWalletIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/transfer_funds",
    fontSize: "1rem",
  },
  {
    key: "/transaction",
    name: "Transaction",
    element: <ReceiptIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/transaction",
    fontSize: "1rem",
  },
  {
    key: "/bank_account",
    name: "Bank Accounts",
    element: <AccountBalanceIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/bank_account",
    fontSize: "1rem",
  },
  {
    key: "/super_admin",
    name: "Admin",
    element: <GrUserAdmin style={{ fontSize: "1.1rem" }} />,
    path: "/admin/super_admin",
    fontSize: "1rem",
  },
  {
    key: "/sub_admin",
    name: "Sub Admin",
    element: <SupervisorAccountIcon style={{ fontSize: "1.1rem" }} />,
    path: "/admin/sub_admin",
    fontSize: "1rem",
  },
];

const toPermissionKey = (label) =>
  label.trim().replace(/\s+/g, "_").toUpperCase();

export const getPermissionObjects = (userPermissions) => {
  const permittedMenu = rawMenu.filter((item) =>
    userPermissions.includes(toPermissionKey(item.name)),
  );
  const permittedPaths = permittedMenu.map((m) => m.path);

  const defaultRoute = permittedPaths[0] || "/";

  return { permittedMenu, permittedPaths, defaultRoute };
};
